import { useTranslation } from "@opendash/i18n";
import { Checkbox, Form, Select } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { PathContext } from "../../../../context/PathContext";
import { TicketMetaField } from "../../../../types/field_configs/Meta";

type Props = {
  field: Extract<TicketMetaField, { type: "select" }>;
};

export const SelectOptions = observer((props: Props) => {
  const t = useTranslation();
  const path = useContext(PathContext);

  return (
    <>
      <Form.Item
        name={[...path, "options"]}
        label={t("maintenance:ticket.creation.config.form.field.options")}
      >
        <Select mode="tags" />
      </Form.Item>

      <Form.Item
        name={[...path, "multiple"]}
        label={t("maintenance:ticket.creation.config.form.field.multiple")}
        valuePropName="checked"
      >
        <Checkbox />
      </Form.Item>
    </>
  );
});
